import React from 'react';
import { UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter } from '../../../ObjektVyer/Bokforder/Queries/BokforderKodbehorigheter/_QueryTypes/UserBokforderKodbehorigheterQuery';
import {
  AdditionalAttestDialogOpenEnum,
  CreateDialogOpenEnum,
} from '../Components/BokforderProviderWrapper';
import {
  BokforderWrapperQuery_db_SYSBokfar_All,
  BokforderWrapperQuery_db_SYSUser_All,
} from '../Queries/_QueryTypes/BokforderWrapperQuery';
import { EKBokforderSysoptionQuery_db_SYSOptions_All } from '../Queries/_QueryTypes/EKBokforderSysoptionQuery';

export interface IBokforderWrapperContext {
  allBokfar: BokforderWrapperQuery_db_SYSBokfar_All[];
  allBFOUsers: UserBokforderKodbehorigheterQuery_userBokforderKodbehorigheter[];
  allBFOUsersLoading: boolean;
  createOptionDialogOpen: CreateDialogOpenEnum;
  currentUser: BokforderWrapperQuery_db_SYSUser_All | undefined;
  currentUserDataLoading: boolean;
  isEconomyPersonnel: boolean;
  reservAttestDialogOpen: AdditionalAttestDialogOpenEnum;
  setCreateOptionDialogOpen: React.Dispatch<
    React.SetStateAction<CreateDialogOpenEnum>
  >;
  setAdditionalAttestDialogOpen: React.Dispatch<
    React.SetStateAction<AdditionalAttestDialogOpenEnum>
  >;
  sysOptions: EKBokforderSysoptionQuery_db_SYSOptions_All[] | null | undefined;
}

export const BokforderWrapperContext =
  React.createContext<IBokforderWrapperContext>({
    allBokfar: [],
    allBFOUsers: [],
    allBFOUsersLoading: false,
    createOptionDialogOpen: CreateDialogOpenEnum.CLOSED,
    currentUser: undefined,
    currentUserDataLoading: false,
    isEconomyPersonnel: false,
    reservAttestDialogOpen: AdditionalAttestDialogOpenEnum.CLOSED,
    setCreateOptionDialogOpen: (
      value: React.SetStateAction<CreateDialogOpenEnum>
    ): void => {
      throw new Error(
        `setCreateOptionDialogOpen not implemented when trying to update with ${value}.`
      );
    },
    sysOptions: [],
    setAdditionalAttestDialogOpen: (
      value: React.SetStateAction<AdditionalAttestDialogOpenEnum>
    ): void => {
      throw new Error(
        `setReservAttestDialogOpen not implemented when trying to update with ${value}.`
      );
    },
  });
